import { Phone, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-omni-background-secondary border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Company Info */}
          <div>
            <div className="mb-6">
              <img
                src="/omnimet-logo.png"
                alt="Omnimet Private Limited"
                className="h-20 w-auto object-contain"
              />
            </div>
            <p className="text-omni-text-secondary text-sm leading-relaxed">
              Elite stockist and contract manufacturer specializing in premium Aluminium and
              Stainless Steel Round Bars and Pipes for global industries.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-heading font-medium text-lg mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="/"
                  className="text-omni-text-secondary hover:text-omni-accent transition-colors text-sm"
                >
                  Home
                </a>
              </li>
              <li>
                <a
                  href="/about"
                  className="text-omni-text-secondary hover:text-omni-accent transition-colors text-sm"
                >
                  About Us
                </a>
              </li>
              <li>
                <a
                  href="/products"
                  className="text-omni-text-secondary hover:text-omni-accent transition-colors text-sm"
                >
                  Products
                </a>
              </li>
              <li>
                <a
                  href="/contact"
                  className="text-omni-text-secondary hover:text-omni-accent transition-colors text-sm"
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-heading font-medium text-lg mb-6">Get in Touch</h3>
            <div className="space-y-4 text-sm">
              <div className="flex items-start gap-3">
                <Phone className="w-4 h-4 text-omni-accent mt-1 flex-shrink-0" />
                <a
                  href="tel:+919958584300"
                  className="text-omni-text-secondary hover:text-omni-accent transition-colors"
                >
                  +91 99585 84300
                </a>
              </div>
              <div className="flex items-start gap-3">
                <Mail className="w-4 h-4 text-omni-accent mt-1 flex-shrink-0" />
                <div className="flex flex-col gap-1">
                  <a
                    href="mailto:info@omnimet.co.in"
                    className="text-omni-text-secondary hover:text-omni-accent transition-colors"
                  >
                    info@omnimet.co.in
                  </a>
                  <a
                    href="mailto:omnimet.info@gmail.com"
                    className="text-omni-text-secondary hover:text-omni-accent transition-colors"
                  >
                    omnimet.info@gmail.com
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-omni-accent mt-1 flex-shrink-0" />
                <p className="text-omni-text-secondary leading-relaxed">
                  23, NIT 3, Faridabad,
                  <br />
                  Haryana - 121001, India
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-white/10 text-center">
          <p className="text-omni-text-secondary text-sm">
            © {new Date().getFullYear()} Omnimet Private Limited. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
